import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { SvgIconEl } from "common/components/svg-icon";
import { hasSlot } from "common/util/dom";
import { formatText } from "common/util/format-text";
import { ButtonTheme } from "../button/constants";
import { getIcon } from "./helpers";
import { getImage } from "./helpers";
const BodyTextClassName = `banner-body`;
export function CoreBanner(banner, actionNode) {
  let bodyTextNode = null;
  if (hasSlot(banner, `body-text`)) {
    bodyTextNode = /* @__PURE__ */ jsx("slot", {
      sel: `.${BodyTextClassName}`,
      attrs: { name: `body-text` },
      class: {
        [`${banner.attr(`theme`)}-theme`]: true
      }
    });
  } else if (banner.attr(`body-text`)) {
    bodyTextNode = /* @__PURE__ */ jsx("div", {
      sel: `.${BodyTextClassName}`,
      class: {
        [`${banner.attr(`theme`)}-theme`]: true
      }
    }, formatText(banner.attr(`body-text`)));
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".banner-wrapper",
    class: {
      [`${banner.attr(`type`)}-type`]: true,
      [`${banner.attr(`theme`)}-theme`]: true
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".banner-panel",
    class: {
      "has-cta": !!actionNode,
      [`${banner.attr(`size`)}-size`]: true,
      [`${banner.attr(`theme`)}-theme`]: true,
      [`${banner.attr(`type`)}-type`]: true,
      "body-only": Boolean(bodyTextNode) && !banner.attr(`header-text`)
    }
  }, getImage(banner) ? /* @__PURE__ */ jsx("img", {
    sel: ".banner-image",
    attrs: { src: getImage(banner) }
  }) : getIcon(banner) ? /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".banner-title-icon",
    attrs: {
      icon: getIcon(banner)
    },
    class: { "banner-copy-no-header": !banner.attr(`header-text`) }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".banner-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".banner-copy",
    class: {
      "banner-copy-no-header": !banner.attr(`header-text`),
      [`${banner.attr(`theme`)}-theme`]: true
    }
  }, banner.attr(`header-text`) ? /* @__PURE__ */ jsx("header", {
    sel: ".banner-header",
    class: { [`${banner.attr(`theme`)}-theme`]: true }
  }, banner.attr(`header-text`)) : null, bodyTextNode, banner.attr(`footer-text`) ? /* @__PURE__ */ jsx("footer", {
    sel: ".banner-footer"
  }, banner.attr(`footer-text`)) : null), actionNode ? /* @__PURE__ */ jsx("div", {
    sel: ".banner-actions",
    class: {
      [`${banner.attr(`theme`)}-theme`]: true
    }
  }, actionNode) : null)));
}
export function template() {
  const hasCta = this.attr(`ctas`) && this.attr(`ctas`).length > 0;
  const ctaNode = hasCta ? /* @__PURE__ */ jsx(null, null, this.attr(`ctas`).map((cta) => {
    const isEmbedded = this.attr(`type`) === this.helpers.BannerType.Embedded;
    const isSmall = this.attr(`size`) === this.helpers.BannerSize.Small;
    const embeddedTheme = isSmall ? ButtonTheme.Tertiary : ButtonTheme.Secondary;
    const shownTheme = isEmbedded ? embeddedTheme : cta.theme || embeddedTheme;
    const shouldShowXIcon = isSmall && cta.actionName === this.helpers.BannerAction.Dismiss;
    return /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".cta-button",
      attrs: {
        theme: shownTheme,
        icon: shouldShowXIcon ? `x` : cta.icon,
        type: this.helpers.getButtonType()
      },
      class: {
        "banner-action-button-embedded": isEmbedded,
        [`${this.attr(`theme`)}-theme`]: true
      },
      on: { click: () => this.helpers.handleCtaButtonClick(cta) }
    }, !shouldShowXIcon ? cta.text : null);
  })) : null;
  return CoreBanner(this, ctaNode);
}
